export const getStyles = ({ companyIndex }) => ({
	featuredCompanyHeader: {
		wrapper:
			"tw:py-2 tw:px-2 tw:flex tw:justify-center tw:bg-[#359492] tw:text-white tw:rounded-t-lg",
		contentWrapper:
			"tw:text-center tw:text-base tw:font-bold tw:leading-6 tw:tracking-[-0.16px]",
	},
	serviceFlag: {
		wrapper: "",
		flag: `tw:absolute tw:top-4 tw:left-4 tw:w-6 tw:h-6 tw:flex tw:items-center tw:justify-center tw:rounded-full tw:lg:w-8 tw:lg:h-8 tw:lg:top-2/4 tw:lg:-translate-y-2/4 ${
			companyIndex === 0
				? "tw:bg-[#616096] tw:text-white"
				: "tw:bg-[#EDEDEE] tw:text-[#22293A]"
		}`,
		number:
			"tw:text-current tw:text-sm tw:font-medium tw:leading-normal tw:lg:text-base tw:lg:leading-6",
		contentWrapper:
			"tw:absolute tw:top-4 tw:left-12 tw:py-1 tw:pl-2 tw:pr-4 tw:flex tw:items-center tw:gap-2 tw:bg-[#359492] tw:text-white tw:[clip-path:polygon(100%_0,calc(100%-10px)_50%,100%_100%,0_100%,0_0)] tw:lg:top-6 tw:lg:left-0",
		icon: "tw:inline-flex",
		text: "tw:text-xs tw:font-semibold tw:leading-4",
	},
	companyLogo: { picture: "tw:flex", image: "tw:w-[232px] tw:max-w-full" },
	rating: {
		wrapper: "tw:inline-flex tw:w-fit tw:items-center tw:gap-2",
		score:
			"tw:text-[30px] tw:font-bold tw:leading-[30px] tw:tracking-[-0.3px] tw:text-[#22293A] tw:lg:text-[44px] tw:lg:leading-[43px] tw:lg:tracking-[-1.76px]",
		stars: "tw:flex tw:flex-col tw:gap-1 tw:lg:gap-0.5",
		starColor: "tw:text-[#359492]",
		starSize: "tw:gap-px tw:text-sm tw:lg:text-xl",
		count:
			"tw:text-xs tw:font-semibold tw:leading-3 tw:text-[#22293A] tw:lg:text-lg tw:lg:leading-[22px]",
	},
	productDescription:
		"tw:text-pretty tw:text-lg tw:font-bold tw:leading-[26px] tw:text-[#131D2B] tw:lg:max-w-[460px] tw:lg:text-2xl tw:lg:leading-8 tw:lg:tracking-[-0.24px]",
	medicationDetails: {
		wrapper: "tw:flex tw:flex-col tw:gap-2",
		format:
			"tw:flex tw:gap-2 tw:text-sm tw:font-semibold tw:leading-6 tw:text-[#0A469E] tw:lg:text-base",
		formatIcon: "tw:text-2xl",
		actives:
			"tw:flex tw:gap-2 tw:text-sm tw:font-semibold tw:leading-6 tw:text-[#22293A] tw:lg:text-base",
		activesIcon: "tw:text-2xl tw:text-[#2A7675]",
	},
	benefitsList: {
		wrapper: "",
		list: "tw:flex tw:flex-col tw:gap-2 tw:justify-center",
		listItem:
			"tw:flex tw:text-[#22293A] tw:text-sm tw:gap-2 tw:leading-6 tw:text-pretty tw:lg:text-base",
	},
	socialProof: {
		wrapper:
			"tw:relative tw:flex tw:h-9 tw:items-center tw:justify-center tw:rounded-b-lg tw:bg-[#F5F3FF] tw:lg:mb-3.5 tw:lg:h-auto tw:lg:max-w-fit tw:lg:rounded-lg tw:lg:bg-white tw:lg:p-2 tw:lg:filter-[drop-shadow(0px_0px_1px_rgba(88,102,126,0.48))_drop-shadow(0px_0px_24px_rgba(88,102,126,0.10))] tw:lg:after:absolute tw:lg:after:right-[calc(50%-6px)] tw:lg:after:top-full tw:lg:after:h-2.5 tw:lg:after:w-2.5 tw:lg:after:-translate-y-2/4 tw:lg:after:rotate-45 tw:lg:after:overflow-hidden tw:lg:after:bg-white tw:lg:after:pointer-events-none",
		contentWrapper:
			"tw:flex tw:flex-row tw:justify-center tw:items-center tw:gap-2",
		contentIcon: "tw:text-[#616096] tw:text-xl tw:lg:text-[28px]",
		content:
			"tw:text-xs tw:font-semibold tw:leading-4 tw:text-left tw:text-[#22293A] tw:lg:w-[98px] tw:lg:text-[11px] tw:lg:leading-[14px]",
	},
	visitLink: {
		wrapper:
			"tw:inline-flex tw:w-full tw:group tw:justify-center tw:items-center tw:p-2 tw:bg-[#359492] tw:rounded-lg tw:transition tw:duration-300 tw:gap-2 tw:cursor-pointer tw:hover:bg-[#246161] tw:lg:py-3",
		contentWrapper:
			"tw:text-white tw:font-semibold tw:leading-6 tw:text-sm tw:text-center tw:lg:text-base tw:lg:tracking-[-0.16px]",
		iconClass:
			"tw:hidden tw:text-2xl tw:text-white tw:transition-all tw:duration-300 tw:group-hover:translate-x-1 tw:lg:inline-flex",
	},
	couponDescription: {
		wrapper:
			"tw:relative tw:w-full tw:rounded-lg tw:border tw:border-dashed tw:border-[#D16104] tw:bg-white tw:p-[5px] tw:lg:p-1",
		icon: {
			wrapper:
				"tw:absolute tw:-top-px tw:right-[22px] tw:h-px tw:w-6 tw:bg-white",
			content:
				"tw:absolute tw:left-1/2 tw:top-1/2 tw:-translate-x-1/2 tw:-translate-y-1/2 tw:text-base tw:text-[#D16104]",
		},
		content:
			"tw:flex tw:items-center tw:justify-center tw:rounded-sm tw:bg-[#FDF8ED] tw:py-1 tw:text-center tw:text-sm tw:font-bold tw:leading-5 tw:text-[#D16104] tw:lg:py-3.5 tw:lg:text-base",
	},
});
